<template>
  <div id="app" class="hyphens-auto">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isEmpty } from "lodash";

export default {
  name: "App",
  components: {},
  computed: {
    ...mapGetters("dlGroupConfig", {
      getDlGroupName: "getDlGroupName",
    }),
  },
  created: function () {
    if (this.loggedIn) {
      this.$store.dispatch("dlGroupConfig/getConfig").then(() => {
        document.documentElement.title = this.getDlGroupName;
        document.title = this.getDlGroupName;
      });

      if (isEmpty(this.user)) {
        this.$store.dispatch("user/fetchProfile").then((res) => {
          if (res !== false) {
            //this.$i18n.locale = res.language;
          }
        });
      } else {
        //this.$i18n.locale = this.user.language;
      }
    }

    const html = document.documentElement; // returns the html tag
    html.setAttribute("lang", "de");
    //this.$i18n.locale);
  },
  destroyed() {
    // ApiService.unmount401Interceptor();
  },
};
</script>

<style lang="sass">
@import "./assets/scss/main.scss"
</style>
